import { FiStar, FiMapPin } from "react-icons/fi";
import { motion } from "framer-motion";
import "./Testimonials.css";


function Testimonials() {


const reviews = [

{
name:"Michael R.",
location:"Cape Town",
service:"Emergency Lockout",
text:"Locked myself out late at night and they arrived quickly. Professional, friendly, and had the door open without any damage."
},


{
name:"Sarah M.",
location:"Claremont",
service:"Home Security Upgrade",
text:"Excellent service from start to finish. They recommended better locks for our home and explained everything clearly."
},


{
name:"David K.",
location:"Century City",
service:"Commercial Locksmith",
text:"Reliable and professional team. They upgraded our office security system and completed the work perfectly."
}


];



return (

<section className="testimonials">


<div className="container">


<motion.div

className="testimonial-header"

initial={{opacity:0,y:30}}

whileInView={{opacity:1,y:0}}

viewport={{once:true}}

>


<span>
CUSTOMER REVIEWS
</span>


<h2>
Trusted By Homeowners And Businesses Across Cape Town
</h2>


<p>
Real experiences from customers who needed fast,
professional locksmith assistance.
</p>


</motion.div>





<div className="review-grid">


{
reviews.map((review,index)=>(


<motion.div

className="review-card"

key={index}


initial={{
opacity:0,
y:40
}}


whileInView={{
opacity:1,
y:0
}}


viewport={{
once:true
}}


transition={{
delay:index*.15
}}

>


<div className="stars">

{
[1,2,3,4,5].map((star)=>(

<FiStar key={star}/>

))
}

</div>



<p className="review-text">

"{review.text}"

</p>



<div className="review-service">

{review.service}

</div>



<div className="customer">


<div className="avatar">

{review.name.charAt(0)}

</div>



<div>

<h4>
{review.name}
</h4>


<span>
<FiMapPin/>
{review.location}
</span>

</div>


</div>



</motion.div>


))
}


</div>




<motion.div

className="review-cta"

initial={{opacity:0,y:30}}

whileInView={{opacity:1,y:0}}

viewport={{once:true}}

>


<h3>
Need a locksmith you can trust?
</h3>


<a href="tel:+27604971899">
Call Emergency Locksmith
</a>


</motion.div>



</div>


</section>


)

}


export default Testimonials;